import React, { useEffect, useState } from 'react'
import Loader from '../../components/loader/Loader';
import Loader2 from '../../components/loader/Loader2';
import { fetchUserByEmailAddress, updateUserProfile } from '../../../services/Admin';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';


function UpdateUser() {
  const [isLoading, setIsLoading] = useState(false);
  const [isPending, setIsPending] = useState(false);
  const [showProfileUpdate, setShowProfileUpdate] = useState(false);
  const [currentEmailAddress, setCurrentEmailAddress] = useState("");

  const [formData, setFormData] = useState({
    email: "",
    name: "",
    phone: "",
    address: "",
    password: "",
    blockStatus: "",
  });

  const location = useLocation();
  const [queryEmail, setQueryEmail] = useState("");


  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const email = queryParams.get('email');
    if (email) {
      setQueryEmail(email);
      setCurrentEmailAddress(email);
    }
  }, [location.search]);
  
  useEffect(() => {
    if (queryEmail) {
      fetchUserDetails(queryEmail);
    }
  }, [queryEmail]);


  const handleInputChange = (event) => {
    const { name, value } = event.target;

    if (name === "blockStatus") {
      setFormData({
        ...formData,
        [name]: value,
      });
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async () => {
    setIsPending(true);
    try {
      const data = await updateUserProfile(formData);
      if(data){
        toast.success("User updated successfully.");
        // console.log(data)
      } else {
        toast.error("Failed to update user, please try again.");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsPending(false);
    }
  }

  const fetchUserDetails = async () => {
    setIsPending(true);
    try {
      const data = await fetchUserByEmailAddress(currentEmailAddress);
      if(data && data.message === "user not found"){
        setShowProfileUpdate(false);
        toast.error("User not found, please try again.");
      } else {
        setFormData({
          email: data.email,
          name: data.name || "",
          password: data.password || "",
          phone: data.phone || "",
          address: data.address || "",
          blockStatus: data.blockStatus || "Unblock",
        });
        setShowProfileUpdate(true);
        console.log(formData)
        toast.success("User found, you can now update the profile.");
      }
    } catch (error) {
      console.error(error);
      setShowProfileUpdate(false);
    } finally {
      setIsPending(false);
    }
  }


  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="deposit">
          <h1 className="main-heading">Profile Update</h1>

          {isPending && <Loader2 />}
          <div className="adpa-first">
            <div className="adpafi-top">
              <h2>Enter User Email</h2>
            </div>
            <div className="adpafi-body">
              <div className="input-group">
                <label>Email Address</label>
                <input
                  type="text"
                  name="email"
                  placeholder='Enter email address'
                  value={currentEmailAddress}
                  onChange={(event)=>setCurrentEmailAddress(event.target.value)}
                />
              </div>
              <div className="button-group">
                <button type="button" onClick={()=>{fetchUserDetails(false)}}>
                  Continue
                </button>
              </div>
            </div>
          </div>

          {showProfileUpdate && (
            <div className="adpa-first">
              <div className="adpafi-top">
                <h2>Update Profile</h2>
              </div>
              <div className="adpafi-body">
                {/* Display user details here */}
                    <div className="input-group">
                      <label>Full name</label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        maxLength="20"
                        required
                      />
                    </div>
                    <div className="input-group">
                      <label>Password</label>
                      <input
                        type="text"
                        name="password"
                        value={formData.password}
                        onChange={handleInputChange}
                        maxLength="20"
                        required
                      />
                    </div>

                    <div className="input-group">
                      <label>Mobile number</label>
                      <input
                        type="text"
                        name="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="input-group">
                      <label>Address</label>
                      <input
                        type="text"
                        name="address"
                        value={formData.address}
                        onChange={handleInputChange}
                      />
                    </div>

                    

                    <div className="input-group">
                      <label>Block Status</label>
                      <select
                        name="blockStatus"
                        value={formData.blockStatus}
                        onChange={handleInputChange}
                      >
                        <option value="Unblock">Unblock</option>
                        <option value="Block">Block</option>
                      </select>
                    </div>

                <div className="button-group">
                  <button type="submit" onClick={handleSubmit}>
                    Update
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  )
}

export default UpdateUser